import { createStyles, makeStyles } from '@mui/styles'

const useStyles = makeStyles((theme) =>
  createStyles({
    root: {
      '.MuiPopover-root': {
        borderRadius: '100px',
        boxShadow: '10px 10px 5px 0px rgba(0,0,0,0.75);',
      },
    },
    text_center: {
      textAlign: 'center',
      justifyContent: 'center !important',
      margin: '0 auto',
    },
    text_left: {
      textAlign: 'left',
      justifyContent: 'flex-start !important',
      margin: '0 auto 0 0',
    },
    left: {
      textAlign: 'left !important',
      justifyContent: 'flex-start !important',
      margin: '0 auto 0 0',
      '& span': {
        textAlign: 'left !important',
      },
    },
    page_wrapper: {},
    page_content: {
      position: 'relative',
      height: 'calc(100vh - 85px)',
      transition: '0.8s',
      '@media screen and (max-width: 1400px)': {
        height: 'calc(100vh - 150px)',
      },
      '& .MuiPaper-root': {
        background: '#fff',
        height: '100%',
        transition: '0.3s',
      },
      '& .Mui-TableHeadCell-Content-Labels': {
        alignItems: 'flex-start',
        width: '100%',

        '& .MuiButtonBase-root.MuiIconButton-root:not(.hide-col-btn)': {
          transform: 'translateY(30px)',
        },

        '& .MuiBadge-root': {
          position: 'absolute',
          right: 5,
        },

        '& .Mui-TableHeadCell-Content-Wrapper:not(:last-child)': {
          '& >div>span:first-child': {
            display: 'block',
            paddingRight: 20,
          },
          '& >div>span:nth-child(2)': {
            display: 'block',
            paddingRight: 0,
          },
        },

        '& .Mui-TableHeadCell-Content-Wrapper': {
          width: '100%',
        },
      },
      '& .MuiBadge-root': {
        transform: 'translateY(3px)',
      },
      '& .MuiBox-root': {
        background: '#fff',
      },
      '& .MuiTableContainer-root': {
        height: 'calc(100%)',
        transition: '0.3s',
        '& + div': {
          display: 'none',
        },
      },
      '& .MuiTableRow-root': {
        backgroundColor: 'transparent !important',
        '&:hover': {
          '& td': {
            backgroundColor: 'rgb(242, 242, 242) !important',
          },
        },
      },

      '& th': {
        '&:not(:nth-child(2))': {
          '& .Mui-TableHeadCell-Content': {
            justifyContent: 'flex-end',
          },
        },
        '&:nth-child(2), &:nth-child(3)': {
          '& .Mui-TableHeadCell-Content-Wrapper': {
            // textAlign: 'left',
          },
        },

        '&:nth-child(8), &:nth-child(9), &:nth-child(10)': {
          '& .Mui-TableHeadCell-Content-Wrapper': {
            // textAlign: 'center',
          },
        },
        padding: 0,
        fontWeight: 800,
        fontSize: 14,
        textAlign: 'right',
        minHeight: 84,
        '& .Mui-TableHeadCell-Content': {
          width: '100%',
          height: '100%',
          padding: '15px 12px 10px',
          display: 'flex',
          alignItems: 'flex-start',
        },

        '& th:first-child': {
          '& .Mui-TableHeadCell-ResizeHandle-Wrapper': {
            display: 'none',
          },
        },

        '& .Mui-TableHeadCell-ResizeHandle-Wrapper': {
          width: 1,
          background: 'transparent',
          height: '100%',
          top: 0,
          bottom: 0,
          right: '15px',
        },
      },
      '& th:not(:last-child)': {
        borderRight: '1px solid rgba(196, 196, 196, 0.25)',
      },
      '& tr': {
        '&:hover': {
          '& td': {
            // backgroundColor: 'rgb(242, 242, 242) !important',
          },
        },
        '& td': {
          // borderBottom: '1px solid rgba(196, 196, 196, 0.25)',
          // fontWeight: 300,
          // fontSize: 14,
          // textTransform: 'capitalize',
          // padding: 12,
        },
        '& td:not(:last-child)': {
          borderRight: '1px solid rgba(196, 196, 196, 0.25)',
        },
        '& td:not(:first-child):not(:nth-child(2))': {
          justifyContent: 'center',
        },
        '& td:nth-child(8), td:nth-child(9), td:nth-child(10)': {
          // justifyContent: 'center !important',
        },
      },
    },
    header_col: {
      display: 'flex',
      flexDirection: 'column',
      gap: '5px',
      '& > span': {
        textAlign: 'center',
      },
    },
    name_td: {
      display: '-webkit-box',
      '-webkit-line-clamp': 2,
      '-webkit-box-orient': 'vertical',
      overflow: 'hidden',
      textOverflow: 'ellipsis',
    },
    transform_td: {
      paddingRight: 20,
      '& + span': {
        position: 'absolute',
        right: 0,
      },
    },
    active_count: {
      padding: '0 10px',
    },
    td_acos: {
      width: 50,
      height: 23,
      borderRadius: 5,
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      fontWeight: 600,
      fontSize: 14,
      lineHeight: 1,
      '&.white': {
        background: '#fff',
      },
      '&.red': {
        background: '#FFD9E0',
      },
      '&.blue': {
        background: '#97F0FF',
      },
    },
    bgFix: {
      width: '100%',
      height: 80,
      background: 'white',
      position: 'fixed',
      zIndex: 99,
    },
    headline: {
      display: 'flex',
      alignItems: 'center',
      flexDirection: 'column',
      gap: 20,
      width: '100%',
      minWidth: '1250px',
      padding: '20px 0',
      // transition: '0.3s',

      '& $headline_sliders_row': {
        maxHeight: '150px',
        transition: '0.3s',
        marginTop: 0,
        overflow: 'hidden',
      },
      '@media screen and (max-width: 1600px)': {
        minWidth: '500px',
      },
    },
    headline_collapsed: {
      // marginTop: -66,

      '& $headline_sliders_row': {
        maxHeight: 0,
        marginTop: -20,
        overflow: 'hidden',
      },
      '@media screen and (max-width: 1400px)': {
        // marginTop: -131,
      },
    },
    expanded_content: {
      height: 'calc(100vh - 150px)',
      transition: '0.1s !important',
      '@media screen and (max-width: 1600px)': {
        height: 'calc(100vh - 217px)',
      },
      '@media screen and (max-width: 1400px)': {
        height: 'calc(100vh - 280px)',
      },
    },
    headline_row: {
      display: 'flex',
      alignItems: 'center',
      gap: 20,
      width: '100%',
    },
    headline_sliders_row: {
      '@media screen and (max-width: 1600px)': {
        display: 'grid',
        gridTemplateColumns: '1fr 1fr 1fr',
      },
      '@media screen and (max-width: 1350px)': {
        gridTemplateColumns: '1fr 1fr',
      },
    },
    headline_bottom_row: {
      '@media screen and (max-width: 1400px)': {
        flexDirection: 'column',
        alignItems: 'flex-start',
        '& $headline_filter': {
          width: '100%',
          '& $headline_select': {
            maxWidth: 'unset',
            marginRight: 10,
          },
          '& $headline_date': {
            marginRight: 10,
          },
          '& $headline_search': {
            marginRight: 0,
          },
        },
        '& $headline_save': {
          marginLeft: 'auto',
        },
      },
    },
    headline_filter: {
      display: 'flex',
      alignItems: 'center',
      flex: 1,
      '& > *': {
        flex: 'auto',
        '&': {
          marginRight: theme.spacing(2.5),
        },
      },
    },
    headline_select: {
      width: 'calc((100% - 100px) / 5)',
      maxWidth: 320,
      '& > div': {
        width: '100%',
        maxWidth: '100%',
      },
      '& > div > div': {
        width: '100%',
        maxWidth: '100%',
      },
      '@media screen and (max-width: 1600px)': {
        maxWidth: 164,
      },
      '& .custom-select__label': {
        fontSize: '10px !important',
      },
      '& .MuiSelect-select': {
        height: '45px !important',
        fontSize: '14px !important',
        paddingTop: '20px !important',
      },
    },
    headline_slider: {
      width: '100%',
      maxWidth: 320,
      '&:nth-child(3)': {
        maxWidth: 320,
      },
      '& > .MuiBox-root': {
        height: 45,
      },
      '@media screen and (max-width: 1600px)': {
        maxWidth: '100%',
        '&:nth-child(3)': {
          maxWidth: '100%',
        },
      },
    },
    headline_search: {
      width: 'calc((100% - 100px) / 5)',
      maxWidth: 320,
      '@media screen and (max-width: 1600px)': {
        maxWidth: 215,
        width: 215,
      },
      '& input': {
        height: '45px !important',
        fontSize: '14px !important',
      },
    },
    headline_date: {
      width: 'calc((100% - 100px) / 5)',
      maxWidth: 320,
      '& > div > div > div': {
        width: '100%',
      },
      '& > .MuiBox-root ': {
        height: 45,
        lineHeight: 1.34,

        '& > [role="button"]': {
          fontSize: 14,

          '& span': {
            fontSize: 10,
          },
        },
      },
      '@media screen and (max-width: 1600px)': {
        maxWidth: 164,
        '& > .MuiBox-root ': {
          '& > [role="button"]': {
            fontSize: '12px !important',
          },
        },
      },
      '@media screen and (max-width: 1500px)': {
        width: 'calc((100% - 100px) / 4)',
      },
      '@media screen and (max-width: 1100px)': {
        width: 'calc((100% - 100px) / 3)',
      },
      '@media screen and (max-width: 1000px)': {
        '& > .MuiBox-root ': {
          '& > [role="button"]': {
            fontSize: '11px !important',
          },
        },
      },
    },
    headline_save: {
      '& > *:not(:last-child)': {
        marginRight: 10,
      },
    },
    expand_button: {
      '&.MuiButtonBase-root': {
        padding: '0 10px',
        fontSize: 10,
        fontWeight: 300,
        lineHeight: '100%',
        textTransform: 'unset',
        minWidth: 'unset',
      },
      '& svg': {
        transition: '0.3s',
      },
    },
    expanded: {
      '& svg': {
        transform: 'rotate(180deg)',
      },
    },
    align_center: {
      display: 'flex',
      width: '100%',
      textAlign: 'center',
    },
    hide_col: {
      position: 'absolute',
      left: 10,
      top: 40,
      zIndex: 10,
    },
    popover: {
      width: '200px',
      height: '100px',
    },
    popover_header: {
      borderBottom: '1px solid rgba(0, 0, 0, 0.12)',
    },
    csv_btn: {
      fontSize: '14px  !important',
      '& span': {
        marginRight: '2px !important',
      },
      '& .MuiLoadingButton-loadingIndicator': {
        left: '10px !important',
      },
      '&:hover': {
        color: '#fff !important',
      },
    },
  })
)
export default useStyles
